import { createContext, useMemo, useState } from 'react';

import { Step } from '../types';

type StepContextData = {
  activeStep: Step;
  forwardStep: (step: Step) => void;
  backwardStep: (step: Step) => void;
};

const stepContextDefaultValue: StepContextData = {
  activeStep: Step.INITIAL,
  forwardStep: () => null,
  backwardStep: () => null,
};

export const StepContext = createContext<StepContextData>(stepContextDefaultValue);

export const useStepContextValue = (): StepContextData => {
  const [activeStep, setActiveStep] = useState<Step>(Step.INITIAL);

  const forwardStep = (step: Step) => setActiveStep(step + 1);
  const backwardStep = (step: Step) => setActiveStep(step - 1);

  return useMemo(() => ({
    activeStep,
    forwardStep,
    backwardStep,
  }), [activeStep]);
};
